<div *ngIf="show" class="modal-backdrop"></div>
<div class="modal" *ngIf="show" [ngClass]="{ fade: show, show: show }" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 *ngIf="title" class="modal-title">{{ title }}</h5>
                <button *ngIf="canGoBack" type="button" class="back" data-dismiss="modal" aria-label="Close" (click)="back()">
                    <img aria-hidden="true" src="assets/images/arrow-left.svg" />
                </button>
                <button *ngIf="canClose" type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</div>
